import { Component, OnInit } from '@angular/core';
import { AdminUsuarioService } from 'src/app/services/admin-usuario.service';
import { AdminUtilService } from 'src/app/services/admin-utils.service';

@Component({
  selector: 'habil-utils-gerenciador-backups',
  templateUrl: './utils-gerenciador-backups.component.html',
  styleUrls: ['./utils-gerenciador-backups.component.scss']
})
export class UtilsGerenciadorBackupsComponent implements OnInit {
  loading = false;
  private token = '';
  tipos = [
    { label: 'Hábil', value: 'HABIL' },
    { label: 'Chef', value: 'CHEF' }
  ]
  tipo: 'HABIL' | 'CHEF' = 'HABIL';
  arquivos: { key: string, size: number, lastModified: Date }[] = [];
  optionsPasta = {
    HABIL: [
      'habil-pg-1',
      'habil-pg-2',
      'habil-rds-1'
    ],
    CHEF: [
      'default'
    ]
  }
  pasta = 'habil-pg-1';
  ano = '2025';
  mes = '05';
  dia = '02';
  anos = [];;
  meses = [];
  dias = [];

  constructor(private usuarioService: AdminUsuarioService,
    private service: AdminUtilService
  ) {
    this.anos.push("2025", "2026", "2027");
    for (let i = 1; i <= 12; i++) {
      this.meses.push(i.toString().padStart(2, '0'));
    }
    for (let i = 1; i <= 31; i++) {
      this.dias.push(i.toString().padStart(2, '0'));
    }
    const hoje = new Date();
    const date = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 1);
    this.ano = date.getFullYear().toString();
    this.mes = (date.getMonth() + 1).toString().padStart(2, '0');
    this.dia = date.getDate().toString().padStart(2, '0');
  }

  ngOnInit(): void {
    this.usuarioService.getTokenUtils().subscribe({
      next: (val) => {
        this.token = val;
      }
    });
  }

  baixar(row: { key: string, size: number, lastModified: Date }) {
    this.service.getSignedUrl(this.token, this.tipo, row?.key).subscribe({
      next: (val) => {
        if (val?.url) {
          const link = document.createElement('a');
          link.href = val?.url;
          link.download = this.nomeArquivo(row?.key);
          link.click();
        }
      }
    })
  }

  formatBytes(bytes: number, decimals = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${size} ${sizes[i]}`;
  }

  nomeArquivo(key: string) {
    const s = key?.split('/');
    return s[s?.length - 1];
  }

  buscar() {
    this.arquivos = [];
    let prefixo = this.pasta + '/';
    if (this.ano) {
      prefixo += this.ano + '/';
      if (this.mes) {
        prefixo += this.mes + '/';
        if (this.dia) {
          prefixo += this.dia + '/';
        }
      }
    }
    this.loading = true;
    this.service.getFiles(this.token, this.tipo, prefixo).subscribe({
      next: (ret) => {
        this.loading = false;
        this.arquivos = [...ret];
      },
      error: (err) => {
        this.loading = false;
      }
    })
  }

}
